var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-content",attrs:{"role":"main"}},[_c('div',{staticClass:"page-content-overlay",on:{"click":_vm.hideNavigation}}),_c('breadcrumb'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }